import { Checkbox } from '@cred/react-editors/checkbox'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'

const CheckboxInputWithAnalytics = withFieldChangeEvent(Checkbox)

export default CheckboxInputWithAnalytics
